import { TAX_ADDRESS } from '../actions';

const initialState = {
    isFetching: false,
    data: null,
    isError: false,
    dataError: null,
    dialogCreateTaxAddress: false,
    dialogEditAddress: false,
    dialogConfirmDelete: false,
    dialogNotAllowDelete: false,
    editSelected: null,
    deleteSelected: null
};

export default (state = initialState, { type, payload, error }) => {
    switch (type) {
        case TAX_ADDRESS.GET_TAX_ADDRESS_PENDING:
            return { ...state, isFetching: true, isError: false, error: null };

        case TAX_ADDRESS.GET_TAX_ADDRESS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: payload,
            };

        case TAX_ADDRESS.GET_TAX_ADDRESS_FAILED:
            return { ...state, isFetching: false, data: [], isError: true, dataError: error };

        case TAX_ADDRESS.OPEN_DIALOG_CREATE_TAX_ADDRESS:
            return { ...state, dialogCreateTaxAddress: true };

        case TAX_ADDRESS.CLOSE_DIALOG_CREATE_TAX_ADDRESS:
            return { ...state, dialogCreateTaxAddress: false };

        case TAX_ADDRESS.CREATE_TAX_ADDRESS_PENDING:
            return { ...state, isFetching: true, isError: false, dataError: null };

        case TAX_ADDRESS.CREATE_TAX_ADDRESS_SUCCESS:
            return {
                ...state,
                dialogCreateTaxAddress: false,
                isFetching: false,
                data: payload,
            };

        case TAX_ADDRESS.CREATE_TAX_ADDRESS_FAILED:
            return { ...state, dialogCreateTaxAddress: false, isFetching: false, isError: true, dataError: error };

        case TAX_ADDRESS.OPEN_DIALOG_EDIT_ADDRESS:
            return { ...state, dialogEditAddress: true, editSelected: payload };

        case TAX_ADDRESS.CLOSE_DIALOG_EDIT_ADDRESS:
            return { ...state, dialogEditAddress: false };

        case TAX_ADDRESS.EDIT_ADDRESS_PENDING:
            return { ...state, isFetching: true, isError: false, dataError: null };

        case TAX_ADDRESS.EDIT_ADDRESS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                dialogEditAddress: false,
                data: payload,
                editSelected: null
            };

        case TAX_ADDRESS.EDIT_ADDRESS_FAILED:
            return {
                ...state,
                isFetching: false,
                dialogEditAddress: false,
                isError: true,
                dataError: error,
                editSelected: null
            };

        case TAX_ADDRESS.UPDATE_TAX_ADDRESS_PENDING:
            return { ...state, isFetching: true, isError: false, dataError: null };

        case TAX_ADDRESS.UPDATE_TAX_ADDRESS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                dialogCreateTaxAddress: false,
                data: payload
            };

        case TAX_ADDRESS.UPDATE_TAX_ADDRESS_FAILED:
            return { ...state, isFetching: false, dialogCreateTaxAddress: false, isError: true, dataError: error };

        case TAX_ADDRESS.OPEN_DIALOG_CONFIRM_DELETE:
            return { ...state, dialogConfirmDelete: true, deleteSelected: payload };

        case TAX_ADDRESS.CLOSE_DIALOG_CONFIRM_DELETE:
            return { ...state, dialogConfirmDelete: false };

        case TAX_ADDRESS.OPEN_DIALOG_NOT_ALLOW_DELETE:
            return { ...state, dialogNotAllowDelete: true };

        case TAX_ADDRESS.CLOSE_DIALOG_NOT_ALLOW_DELETE:
            return { ...state, dialogNotAllowDelete: false, deleteSelected: null };

        case TAX_ADDRESS.SET_AS_DEFAULT_PENDING:
            return { ...state, isFetching: true, isError: false, dataError: null };

        case TAX_ADDRESS.DELETE_ADDRESS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: payload,
                deleteSelected: null
            };

        case TAX_ADDRESS.DELETE_ADDRESS_FAILED:
            return { ...state, isFetching: false, isError: true, dataError: error, deleteSelected: null };

        case TAX_ADDRESS.DESTROY_ADDRESS_SUCCESS:
            return { ...state, isFetching: false, data: [], deleteSelected: null };

        case TAX_ADDRESS.SET_AS_DEFAULT_SUCCESS:
            return {
                ...state,
                isFetching: false,
                data: payload
            };

        case TAX_ADDRESS.SET_AS_DEFAULT_FAILED:
            return { ...state, isFetching: false, isError: true, dataError: error };

        default:
            return state;
    }
};
